import { type createRoutes, eOpenIddictProComponents } from '@volo/abp.ng.openiddictpro';
import { autoSizeEntityPropColumns } from 'src/app/shared/helpers/extensible-table-columns.helper';

type OpenIddictProEntityPropContributors = NonNullable<Parameters<typeof createRoutes>[0]>['entityPropContributors'];

export const OPENIDDICT_ENTITY_PROP_CONTRIBUTORS = {
  [eOpenIddictProComponents.Applications]: [autoSizeEntityPropColumns],
  [eOpenIddictProComponents.Scopes]: [autoSizeEntityPropColumns],
} as OpenIddictProEntityPropContributors;
